<template>
  <v-form ref="projectForm" lazy-validation>
    <v-row class="mt-3">
      <v-col cols="12" sm="6" xl="4">
        <v-text-field
          outlined
          label="Project Name"
          v-model="projectName"
          :readonly="readonly"
          :rules="[Required('Project Name')]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Required from '@/lib/formValidations/required'

export default {
  props: ['project', 'readonly'],

  computed: {
    projectName: {
      get () {
        return this.project ? this.project.projectName : null
      },
      set (value) {
        this.$emit('setProjectName', value)
      }
    }
  },

  methods: {
    Required,

    isProjectStepValid () {
      return this.$refs.projectForm.validate() ? true : 'Please fill out the required fields to proceed'
    }
  },

  mounted () {
    if (this.$refs.projectForm) {
      this.$refs.projectForm.resetValidation()
    }
  }
}
</script>
